import { html } from 'lit';
import componentStyles from './accordion-item.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class AccordionItem extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      isClosed: { type: Boolean },
      prompt: { type: String },
      response: { type: String },
    };
  }

  constructor() {
    super();
    this.isClosed = true;
  }

  setState(isOpen) {
    const details = this.shadowRoot.querySelectorAll('details');
    if (isOpen) {
      details[0].setAttribute('open', 'true');
    } else {
      details[0].removeAttribute('open');
      this.isClosed = true;
    }
  }

  toggle() {
    this.isClosed = !this.isClosed;
    this.requestUpdate('isClosed', this.isClosed);
  }
  toggleOpen() {
    if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
      const details = this.shadowRoot.querySelectorAll('details');
      details[0].toggleAttribute('open');
    }
  }

  render() {
    return html`
      <details class="accordion__item">
        <summary 
          class="accordion__item--prompt-container"
          @click="${this.toggle}"
        >
          <hf-paragraph
            paragraphStyles="accordion-prompt"
            class="accordion__item--prompt"
            styleclass="accordion-prompt"
            >${this.prompt}
          </hf-paragraph>
          <hf-icon 
            class="accordion__item--icon" 
            name="${this.isClosed ? 'chevron-down' : 'chevron-up'}"
            @click="${this.toggleOpen}"
          >
          </hf-icon>
        </summary>
        <hf-paragraph
          class="accordion__item--response"
          styleclass="accordion-response"
          paragraphStyles="accordion-response"
        >
          <hf-wysiwyg markup="${this.response}"></hf-wysiwyg>
        </hf-paragraph>
      </details>
    `;
  }
}
customElements.define('hf-accordion-item', AccordionItem);
